//@flow
import React from 'react';
import {makeStyles, Hidden, Grid} from '@material-ui/core';
import {PlayCircleFilledTwoTone, ArrowBack} from '@material-ui/icons';

import {useIsFeatureInTier} from '../../../../utils/component';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {TIENDADA_LINKS} from '../../../../constants';
import TagSection from './tag-section';
import {useSetInitialConversationTags} from '../../chat/utils/conversationTag';
import ContactTable from './contact-table';
import UpgradeIcon from '../../../../elements/icons/UpgradeIcon';
import {colors} from '../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-label': {
      gap: '8px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },

  groupSelect: {
    borderRadius: '25px',
    backgroundColor: '#FFFFFF',
    marginBlock: '1rem',
    border: '1px solid #B8B8C7',
    display: 'flex',
    alignItems: 'center',
  },

  sizeSelect: {
    border: 'none!important',
    background: 'unset',

    '& > div': {
      border: 'none!important',
      '&:hover': {
        background: 'unset',
      },
    },
    '&:hover': {
      background: 'unset',
    },
  },
  upgradeButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    margin: '1rem auto',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    '&:hover': {
      backgroundColor: colors.grey200,
    },
  },
  upgradeButtonLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',

    '&[data-disabled="true"]': {
      pointerEvents: 'none',
      opacity: 0.5,
    },
  },
}));

export default function MultichatContacts() {
  const classes = useStyles();

  const hasContactFeature = useIsFeatureInTier('TIENDACHAT_WHATSAPP_WEB');

  useSetInitialConversationTags();

  return (
    <div className={classes.root}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item alignItems="center">
          <Hidden mdUp>
            <CustomButton className={classes.title} to="/client">
              <ArrowBack />
              <div style={{display: 'flex', alignItems: 'center'}}>
                Clientes
              </div>
            </CustomButton>
          </Hidden>
          <Hidden smDown>
            <div
              className={classes.title}
              style={{display: 'flex', alignItems: 'center'}}
            >
              Contactos
            </div>
          </Hidden>
        </Grid>
        <Grid item>
          <CustomButton
            href={TIENDADA_LINKS.tutorials.CRM}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.btnHeader}
            startIcon={<PlayCircleFilledTwoTone />}
          >
            Tutoriales
          </CustomButton>
        </Grid>
      </Grid>

      {!hasContactFeature && (
        <CustomButton className={classes.upgradeButton} to="/tiers-list">
          <div className={classes.whiteButtonLabel}>
            <span>Mejora tu plan para acceder a esta funcionalidad</span>
            <UpgradeIcon width={18} height={18} />
          </div>
        </CustomButton>
      )}

      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={2}
        className={classes.container}
        data-disabled={!hasContactFeature}
      >
        {/* <Grid item xs={12} md={4}>
          <SummaryCard
            icon={<Announcement fontSize="small" />}
            metricCount={10}
            title="Conversaciones abiertas"
            tooltipInfo="El número de conversaciones abiertas"
            percentage={10.45}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard
            icon={<FormatListBulleted fontSize="small" />}
            metricCount={14}
            title="Tareas pendientes"
            tooltipInfo="El número de tareas pendientes"
            percentage={-10.45}
            color={colors.darkWarning}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard
            icon={<Announcement fontSize="small" />}
            metricCount={10}
            title="Mensajes programados pendientes"
            tooltipInfo="El número de mensajes programados pendientes"
            percentage={10.45}
            color={colors.info}
          />
        </Grid> */}

        <Grid item xs={12}>
          <TagSection />
        </Grid>
        <Grid item xs={12}>
          <ContactTable />
        </Grid>
      </Grid>
    </div>
  );
}
